import { PRODUCTS, INDUSTRIES } from "../site/data";

export { PRODUCTS, INDUSTRIES };

export const COMPANY = {
  name: "Laneeka International",
  short: "LANEEKA",
  site: "https://laneeka.com/",
  group: "L&P Industrial Automation Ltd.",
  reference: "beltingbd.com",
  agency: "Guangdong Boshun Belting Co., Ltd.",
  established: 2011,
  phone: "+8801819-850278",
  phoneRaw: "+8801819850278",
  whatsapp: "https://wa.me/8801819850278",
  email: "contact@beltingbd.com",
  facebook: "https://www.facebook.com/Laneeka.int",
  address: "House #5 (Ground Floor), Road #4, Nikunja-2, Khilkhet, Dhaka-1229, Bangladesh",
  hours: "Saturday – Thursday, 9:00 AM – 6:00 PM",
};

export const STORY = [
  "Laneeka International, founded in 2011, is a leading conveyor belting company in Bangladesh. We specialize in high-quality, customized conveyor solutions, earning a reputation as a trusted partner for industries nationwide.",
  "We specialize in providing high-quality conveyor solutions tailored to meet the diverse needs of industries across the country. Our commitment to innovation, customer satisfaction, and top-tier products has positioned us as a trusted partner for businesses seeking reliable and efficient conveyor systems.",
];

export const MD_MESSAGE = {
  quote:
    "Every product we deliver and every service we provide is a testament to our commitment to quality, precision, and reliability. As we look toward the future, Laneeka International will continue to set new benchmarks in the conveyor belting industry by embracing cutting-edge technology, sustainable practices, and customer-centric solutions.",
  name: "Engr. Md. Lahabur Rahman",
  role: "Managing Director",
};

export const MISSION =
  "To provide exceptional products and unmatched service by focusing on innovation, quality, and customer satisfaction — helping businesses enhance efficiency through customized solutions and ensuring long-term success for our clients.";

export const VISION =
  "To be the leading and most trusted partner in industrial belting solutions by consistently delivering innovation, quality, and value to our clients, driving sustainable growth and operational excellence.";

export const VALUES = ["Innovation", "Customer Satisfaction", "Quality", "Employee Wellbeing", "Continuous Development"];

export const TEAM = [
  { name: "Engr. Md. Lahabur Rahman", role: "Managing Director", photo: "/team/lahabur.png" },
  { name: "Nasrin Akther Neepa", role: "Chairman", photo: "/team/neepa.jpg" },
  { name: "Md. Tahidur Rahman (Touhid)", role: "Manager — Sales & Marketing", photo: "/team/touhid.jpg" },
  { name: "Nadia Afrin", role: "Coordinator — Sales & Accounts", photo: "/team/nadia.jpg" },
  { name: "Md. Atik Shahriar", role: "Executive — Sales & Marketing", photo: "/team/atik.jpg" },
  { name: "Jenna Timothy", role: "Customer Relations", photo: "/team/jenna.jpg" },
  { name: "Md. Alimun Rashid Arnob", role: "Overseas Operations Executive", photo: "/team/arnob.jpg" },
  { name: "Md. Salman Shah", role: "Executive — Accounts & Admin", photo: "/team/salman.jpg" },
  { name: "Md. Majbah Uddin Asif", role: "Executive — Sales & Marketing", photo: "/team/asif.jpg" },
  { name: "Md. Mehedi Hasan", role: "Executive — Sales & Marketing", photo: "/team/mehedi.jpg" },
  { name: "Md. Abu Shahin", role: "Team Leader — Technical Services", photo: "/team/shahin.jpg" },
  { name: "Alamgir Hossain", role: "Senior Technician", photo: "/team/alamgir.jpg" },
  { name: "Md. Liton", role: "Technician", photo: "/team/liton.jpg" },
];

export const NEWS = [
  {
    title: "Laneeka International Secures Exclusive Bangladesh Agency of Guangdong Boshun Belting Co., Ltd.",
    date: "October 1, 2025",
    image: "/news/agency.jpg",
    excerpt:
      "Official Announcement — We are proud to share that Laneeka International, a proud sister concern of L&P Industrial Automation Ltd., has been officially appointed as the exclusive Bangladesh agent of Guangdong Boshun Belting Co., Ltd.",
  },
  {
    title: "শুভ বাংলা নববর্ষ ১৪৩২",
    date: "April 14, 2025",
    image: "/news/bangla-newyear.jpg",
    excerpt:
      "নতুন বছরের প্রথম দিনে আপনাকে ও আপনার পরিবারকে জানাই বাংলা নববর্ষের আন্তরিক শুভেচ্ছা ও অভিনন্দন। নতুন বছর হোক শান্তি, সমৃদ্ধি ও আনন্দে ভরে উঠুক।",
  },
  {
    title: "Laneeka International Wishes Everyone a Happy New Year",
    date: "January 1, 2025",
    image: "/news/newyear.jpg",
    excerpt:
      "Wishing all our partners, well-wishers, and people around the world a Happy New Year. May this year bring joy and peace to everyone.",
  },
  {
    title: "সফলতার এক যুগ — গ্রুপের ১৩তম বর্ষপূর্তি উদযাপন",
    date: "October 4, 2024",
    image: "/news/anniversary.jpg",
    excerpt:
      "তেরো বছরের যাত্রায় আমাদের সঙ্গী হওয়ার জন্য সকল গ্রাহক, অংশীদার ও শুভানুধ্যায়ীকে আন্তরিক ধন্যবাদ ও কৃতজ্ঞতা।",
  },
  {
    title: "Welcome to Laneeka International",
    date: "October 4, 2024",
    image: "/news/welcome.jpg",
    excerpt:
      "Established in 2011 as part of the L&P family, Laneeka International has grown to become one of Bangladesh's trusted providers of industrial belting solutions.",
  },
];

export const SERVICES = [
  { name: "Conveyor Belt", desc: "Large scale logistics and industrial conveying solutions." },
  { name: "Modular Belt / Slat Chain", desc: "Durable, interlocking conveyor systems for heavy shipments." },
  { name: "Felt Conveyor Belt", desc: "Gentle, non-marking conveying for perishable and delicate goods." },
  { name: "Specialized Services", desc: "Experienced team managing the complexities of conveyor systems, tailored to your needs." },
  { name: "Expedited Shipping", desc: "When time is of the essence, your shipment arrives as quickly as possible." },
  { name: "Hazardous Materials", desc: "Certified and secure transportation for regulated materials." },
  { name: "Route Optimization", desc: "Efficient routing that saves you time and fuel cost." },
  { name: "Eco-Friendly Logistics", desc: "Sustainable solutions that reduce environmental impact." },
];

export const TESTIMONIALS = [
  {
    text: "When it comes to handling our specialized equipment, we need a partner that understands precision and reliability. Laneeka International has consistently exceeded our expectations, delivering high-quality industrial solutions.",
    author: "Director, Client Company",
  },
  {
    text: "Partnering with Laneeka International has been a game-changer for our operations. The efficiency and reliability they bring to our supply chain have significantly reduced our production challenges.",
    author: "Managing Director, Client Company",
  },
  {
    text: "In the fast-paced world of manufacturing, having a reliable partner is crucial. Laneeka International has been that partner for us, ensuring our production lines run smoothly and efficiently.",
    author: "HR Manager, Client Company",
  },
];

export const LOCATIONS = [
  {
    label: "Head Office",
    address: "House #5 (Ground Floor), Road #4, Nikunja-2, Khilkhet, Dhaka-1229, Bangladesh",
  },
  {
    label: "Factory & Warehouse",
    address: "Matrikunja, 5 Dakshin Para Jame Masjid Road, Dakshin Khan, Dhaka-1230, Bangladesh",
  },
];

export const STATS = [
  { value: "2011", label: "Established" },
  { value: "700+", label: "Happy Clients" },
  { value: "79+", label: "Product Variants" },
  { value: "24h", label: "Response Time" },
];
